// extracted by mini-css-extract-plugin
export default {"wrap":"absenceSupervisor_wrap__+dxzH","absence__panel":"absenceSupervisor_absence__panel__TCWzm","btnGroup":"absenceSupervisor_btnGroup__nrkOT"};